/**
 * Клиентский флаг голосового ввода. Пробрасывается через `env` в next.config.ts и
 * фиксируется на этапе сборки. Если не 'true' — кнопки микрофона не рендерятся вообще.
 */
export const VOICE_INPUT_ENABLED = process.env.NEXT_PUBLIC_VOICE_INPUT_ENABLED === 'true'

/**
 * Поддержка браузером: getUserMedia + MediaRecorder + secure context (HTTPS/localhost).
 * На dev по LAN-IP без HTTPS `mediaDevices` недоступен — кнопка не показывается.
 */
export function isVoiceInputSupported(): boolean {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false
  if (!window.isSecureContext) return false
  if (!navigator.mediaDevices || typeof navigator.mediaDevices.getUserMedia !== 'function') return false
  if (typeof window.MediaRecorder === 'undefined') return false
  return true
}

/** Флаг включён и браузер поддерживает запись. Только на клиенте. */
export function isVoiceInputAvailable(): boolean {
  return VOICE_INPUT_ENABLED && isVoiceInputSupported()
}
